/// <reference path="app.hilo.controllers.module.ts" />
/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../apimodel.d.ts" />
/// <reference path="../../common/controllers/screencontrollerbase.ts" />
/// <reference path="hilocontrollerbase.ts" />

module App.HiLO.Controllers {



    'use strict';

    class UploadTesterController extends HiLOControllerBase<Hca.HiLO.ViewModel.IPermissionToSellViewModel> {
        public static $inject = ['$injector'];
        public model: Hca.HiLO.ViewModel.IPermissionToSellViewModel;
        public api: Common.Services.ApiService;
        public selectedExclusionValue: string;
        public testDirec: string = 'hello';


        constructor($injector: angular.auto.IInjectorService) {
            super($injector);
            this.model = {
                productName: 'Grant consent for you to carry out works or alterations to your property',
                descriptionOfDeed:'xxx',
                contactDetails: {
                    contactAddress: {} as Hca.HiLO.ViewModel.IAddressViewModel
                },
                propertyAddress: {} as Hca.HiLO.ViewModel.IAddressViewModel,
                uploadedFiles: []

            } as Hca.HiLO.ViewModel.IPermissionToSellViewModel;

            this.api = $injector.get<Common.Services.ApiService>('app.common.services.apiService');
            this.title = 'Legal Services';
            this.titleSecondary = 'Grant Permission to Sell or Lease Property.';
          
            this.filesToUpload = [
				{ name: 'Copy of deed', description: '', hasUploaded: false, isAdditional: false, isRequired: true, skipped: false },
				{ name: 'Doc 2', description: '', hasUploaded: false, isAdditional: false, isRequired: true, skipped: false },
				{ name: 'doc 3', description: '', hasUploaded: false, isAdditional: false, isRequired: false, skipped: false }

            ];

            this.currentUpload = this.filesToUpload[0].name;

        }

        public beforeInitialize(): angular.IPromise<any> {
            return this.setAuthenticationRequired(false);
        }

        public initialize(): angular.IPromise<any> {

            return this.$q.resolve();
        }

        public updateSection(value: number, formName: string) {
            this.$window.scrollTo(0, 0);
            this.currentFormName = formName;
            if (this.currentSection < 4 && this.currentSection > -1) {
                this.currentSection = value;
            }

        }





        public save(): angular.IPromise<any> {


            this.userMessages.clear();
            this.$window.scrollTo(0, 0);

            this.refNumberService.getReferenceNumber('W').then((data: string) => {
                this.model.referenceNumber = data;

                //  this.model.referenceNumber = ref;
                this.model.formSubmission = JSON.stringify(this.model);

                var postConfig: Common.IApiRequestConfig = {
                    url: 'api/FormSubmission/ConsentForWorks',
                    authenticated: false,
                    data: this.model
                };

                this.busyPromise = this.api.post(postConfig)
                    .then((r: any) => {
                        this.mainForm().$setPristine();
                        this.$state.go('SubmissionComplete', { id: this.model.referenceNumber, product: '1' });
                    });

                return this.$q.resolve();
            });
            return this.$q.resolve();
        }

    }


    angular
        .module('app.hilo.controllers')
        .controller('app.hilo.controllers.uploadTesterController', UploadTesterController);

}